/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef } from 'react';
import { Button, Modal, Skeleton } from 'antd';
import { useReactToPrint } from 'react-to-print';
import TM30 from './TM30';
import { IOrder, IVehicleInspection } from '@/interfaces/order';
import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { getVehicleDetail } from '@/adapters/order';

interface IProps {
  open: boolean;
  handleCancel: () => void;
  order?: IOrder;
  isTempalte?: boolean;
}

const PrintModal = ({ open, handleCancel, order, isTempalte }: IProps) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const handlePrint = useReactToPrint({
    contentRef,
    documentTitle: `${order?.code || 'เอกสาร'}`,
  });

  const { data, isLoading } = useQuery<
    AxiosResponse<IVehicleInspection[]>,
    Error
  >({
    queryKey: ['get-vehicle-inspection', order?.id],
    queryFn: async () => await getVehicleDetail(Number(order?.id)),
    enabled: !!order?.id && open && !isTempalte,
  });

  return (
    <Modal
      title="พิมพ์เอกสาร"
      open={open}
      width={'1100px'}
      onOk={() => handleCancel}
      onCancel={handleCancel}
      okText="บันทึก"
      cancelText="ยกเลิก"
      footer={[
        <Button key="back" onClick={handleCancel}>
          ปิด
        </Button>,
        <Button type="primary" key="print" onClick={() => handlePrint()}>
          พิมพ์เอกสาร
        </Button>,
      ]}
    >
      <div className="flex flex-col overflow-y-auto bg-gray-200 p-2 max-h-[600px] font-ibm gap-5">
        <div ref={contentRef} className="flex flex-col">
          <Skeleton loading={isLoading}>
            {data?.data?.length &&
              !isTempalte &&
              data?.data?.map((d, i) => {
                return <TM30 key={i} data={d} />;
              })}
            {isTempalte && <TM30 data={{}} />}
          </Skeleton>
        </div>
      </div>
    </Modal>
  );
};

export default PrintModal;
